<section class="hero-banner">
  <div class="hero-banner-overlay">
    <div class="hero-banner-content">
      <h1 style="color: #fff;"><span class="hero-banner-content-span">Technology for</span> <br><span
          class="hero-banner-content-span1">Modern Workplaces</span></h1>
      <p>Future-ready, agile, and adaptive technology solutions that scale with your success..</p>
    </div>
  </div>
</section>

<div class="enterprise-intro-grid">
  <div class="enterprise-intro-text">
    <h2 class="text-2xl font-semibold mb-3">Business</h2>
    <p class="text-gray-700 text-left" style="font-size: 18px;">
      At Superior Digital, we empower organizations with intelligent, scalable, and secure technology solutions designed
      to meet the evolving demands of the modern Business. Our end-to-end offerings ensure seamless integration,
      enhanced productivity, and robust protection across your digital infrastructure.
    </p>
  </div>
  <div class="enterprise-intro-image-container">
    <img src="assets/images/ent1_new.png" alt="Enterprise Icon" class="enterprise-intro-image" />
  </div>
</div>

<br>
<section class="superior-computing-solutions ptb-50" id="av-solutions-for-enterprises">
  <div class="container web-only-section">
    <div class="bg-cover bg-center rounded-lg shadow-lg"
      style="background-image: url('assets/images/aventerperise_new.png'); min-height: 600px; position: relative; border-radius: 20px 0 0 20px;">
      <div class="flex items-center h-full"
        style="position: absolute; right: 0; top: 0; bottom: 0; width: 50%; background: linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%);">
        <div class="text-white p-8" style="background-color: rgb(0 0 0 / 40%); padding: 1.5%; height: 100%;">
          <h1 class="font-bold mb-4" style="font-size: 40px; color: #fff;">AV Solutions for Business</h1>
          <p class="text-lg mb-6" style="font-size: 18px;">At Superior Digital, we understand that effective
            communication drives business success and it begins with a well-designed meeting space. Whether it's a
            compact huddle room or a large boardroom, we architect world class audio-video solutions tailored to your
            room dimensions, usage scenarios, and business expectations. Our process starts with a detailed assessment
            of the space, followed by the selection of the right displays, high performance cameras, and
            professional grade microphones ranging from tabletop to wireless ceiling mics. We integrate intuitive
            controllers and advanced collaboration software with reliable hardware to ensure seamless, high quality
            virtual and in person meetings. From design to deployment, we deliver intelligent AV solutions that enhance
            productivity, collaboration, and the overall meeting experience.</p>
        </div>
      </div>
    </div>
  </div>
  <div class="container mobile-only-section">
    <div class="card bg-white shadow-lg rounded-lg p-4">
      <h2 class="font-bold text-xl mb-2">AV Solutions for Business</h2>
      <img src="assets/images/aventerperise_new.png" alt="AV Solutions for Enterprises"
        class="full-width-image rounded-lg mb-4">
      <p style="font-size: 11px;line-height: 1.5;color: #000;">At Superior Digital, we understand that effective
        communication drives business success and it begins with a well designed meeting space. Whether it's a
        compact huddle room or a large boardroom, we architect world class audio-video solutions tailored to your
        room dimensions, usage scenarios, and business expectations. Our process starts with a detailed assessment
        of the space, followed by the selection of the right displays, high performance cameras, and
        professional grade microphones ranging from tabletop to wireless ceiling mics. We integrate intuitive
        controllers and advanced collaboration software with reliable hardware to ensure seamless, high quality
        virtual and in person meetings. From design to deployment, we deliver intelligent AV solutions that enhance
        productivity, collaboration, and the overall meeting experience. </p>
    </div>
  </div>
</section>

<br>

<section class="superior-computing-solutions ptb-50" id="seamless-network-defense">
  <div class="container web-only-section">
    <div class="bg-cover bg-center rounded-lg shadow-lg"
      style="background-image: url('assets/images/seamless_network_new.png'); min-height: 600px; position: relative; border-radius: 0 20px 20px 0;">
      <div class="flex items-center h-full"
        style="position: absolute; left: 0; top: 0; bottom: 0; width: 50%; background: linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%);">
        <div class="text-white p-8" style="background-color: rgb(0 0 0 / 19%); padding: 7%;height: 100%;">
          <h1 class="font-bold mb-4" style="font-size: 40px; color: #fff;">Seamless Network Defense</h1>
          <p class="text-lg mb-6" style="font-size: 18px;">At Superior Digital, we redefine business computing for
            today's dynamic business landscape. From seamless device deployment and cross-platform integration to
            advanced security, cloud services, and remote management, our business solutions are built to boost
            productivity and simplify IT. With our expertise in Apple and multi-brand ecosystems, we empower
            organizations with scalable, secure, and future-ready infrastructure that adapts to the evolving needs of a
            hybrid workforce.</p>
        </div>
      </div>
    </div>
  </div>
  <div class="container mobile-only-section">
    <div class="card bg-white shadow-lg rounded-lg p-4">
      <h2 class="font-bold text-xl mb-2">Seamless Network Defense</h2>
      <img src="assets/images/seamless_network_new.png" alt="Seamless Network Defense"
        class="full-width-image rounded-lg mb-4">
      <p style="font-size: 11px;line-height: 1.5;color: #000;">At Superior Digital, we redefine business computing
        for
        today's dynamic business landscape. From seamless device deployment and cross-platform integration to
        advanced security, cloud services, and remote management, our business solutions are built to boost
        productivity and simplify IT. With our expertise in Apple and multi-brand ecosystems, we empower
        organizations with scalable, secure, and future-ready infrastructure that adapts to the evolving needs of a
        hybrid workforce.</p>
    </div>
  </div>
</section>
<br>

<section class="enterprise-offerings">
  <div class="offerings-content">
    <div class="enterprise-heading" style="flex-direction: column;">
      <h2>The Superior Edge</h2>
      <p style="color: #fff; font-size: 16px;">Superior Digital delivers advanced technology solutions that boost
        business agility and efficiency by aligning IT with core operations. Backed by a team of 30+ experts, we ensure
        reliable support for all your IT needs—keeping you ahead of the curve.</p>
      <div class="enterprise-learn-more">
      </div>
    </div>

    <div class="enterprise-details">
      <div class="enterprise-highlights">
        <div class="highlight-item">
          <img src="assets/icons/expertise_org.svg" alt="Experience Icon" class="highlight-icon">
          <p>Over 10 Years Of Expertise & Serving 480+ Business Customers.</p>
        </div>
        <div class="highlight-item">
          <img src="assets/icons/team.svg" alt="Team Icon" class="highlight-icon">
          <p>50+ members team skilled and certified to execute Business requirements.</p>
        </div>
        <div class="highlight-item">
          <img src="assets/icons/devices.svg" alt="Solutions Icon" class="highlight-icon">
          <p>Personalised Solutions Enhanced by Service Excellence.</p>
        </div>
        <div class="highlight-item">
          <img src="assets/icons/panindia.svg" alt="Presence Icon" class="highlight-icon">
          <p>Pan India Coverage.</p>
        </div>
        <div class="highlight-item">
          <img src="assets/icons/grp_chat.svg" alt="Consulting Icon" class="highlight-icon">
          <p>Client-centric Consulting Strategy.</p>
        </div>
        <div class="highlight-item">
          <img src="assets/icons/partnership.svg" alt="Partnerships Icon" class="highlight-icon">
          <p>40+ Exclusive Brand Collaborations.</p>
        </div>
      </div>

    </div>
  </div>

</section>

<br>
<section class="enterprise-solutions mt-100 web-only-section" (click)="navigateToAppleEnterprise()"
  style="cursor: pointer;">
  <div class="container2">
    <div class="row" style="margin-left: 0px !important">
      <div class="col-lg-12 col-md-12 mb-4" id="getting-started-with-mac">
        <div class="card bg-image" style="position: relative;">
          <div class="card-top-right-images">
            <img src="assets/images/authres.png" alt="Image 2" class="top-right-img">
          </div>
          <div class="card-content appleenterprise-card">
            <div class="image-section" style="flex: 1; max-width: 50%;">
              <img src="assets/images/apple_enterprisenew.png" alt="Apple Enterprise"
                style="width: 100%; height: auto;">
            </div>
            <div class="content-section">
              <h3 style="margin-bottom: 1rem; font-size: 3rem; font-weight: bold;">Apple for Business</h3>
              <p style="font-size: 18px; line-height: 1.6;">Superior Digital, an Apple Authorised Reseller, delivers
                expertly architected solutions that integrate Apple devices, MDM, and accessories to meet the unique
                needs of every industry. Our end-to-end approach from consulting and deployment to training and ongoing
                service ensures a seamless and future ready IT experience. Customers benefit from increased efficiency,
                simplified management, and a reliable technology partner committed to their long term success.</p>
              <a href="/enterprise-new" class="download-btn">Learn More</a>
            </div>
          </div>
          <div class="card-bottom-left-link">

          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="enterprise-solutions-mobile mt-100 mobile-only-section" style="cursor: pointer;">
  <div class="container2" style="background: rgba(0, 0, 0, 0.55);">
    <div class="row">
      <div class="col-12 mb-4" id="getting-started-with-mac-mobile">

        <div class="content-section">
          <h3 style="margin-bottom: 1rem; font-size: 1.9rem; font-weight: bold; color: #fff;">Apple for Business</h3>
          <p style="font-size: 11px;line-height: 1.5;color: #fff;">Superior Digital, an Apple Authorised Reseller,
            delivers
            expertly architected solutions that integrate Apple devices, MDM, and accessories to meet the unique
            needs of every industry. Our end-to-end approach from consulting and deployment to training and ongoing
            service ensures a seamless and future ready IT experience. Customers benefit from increased efficiency,
            simplified management, and a reliable technology partner committed to their long-term success.</p>
          <a href="/enterprise-new" class="download-btn">Learn More</a>
        </div>

      </div>
    </div>
  </div>
</section>

<br>
<section class="superior-computing-solutions ptb-50" id="enterprise-computing-solutions">
  <div class="container web-only-section">
    <div class="bg-cover bg-center rounded-lg shadow-lg"
      style="background-image: url('assets/images/enterprisecomputing_new.png'); min-height: 600px; position: relative; border-radius: 20px 0 0 20px;">
      <div class="flex items-center h-full"
        style="position: absolute; right: 0; top: 0; bottom: 0; width: 50%; background: linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%);">
        <div class="text-white p-8" style="background-color: rgb(0 0 0 / 40%); padding: 7%; height: 100%;">
          <h1 class="font-bold mb-4" style="font-size: 40px; color: #fff;">Business Computing Solutions</h1>
          <p class="text-lg mb-6" style="font-size: 18px;">At Superior Digital, we redefine business computing for
            today's dynamic business landscape. From seamless device deployment and cross-platform integration to
            advanced security, cloud services, and remote management, our business solutions are built to boost
            productivity and simplify IT.</p>
          <p class="text-lg mb-6" style="font-size: 18px;">With our expertise in Apple and multi-brand ecosystems, we
            empower organizations with scalable, secure, and future-ready infrastructure that adapts to the evolving
            needs of a hybrid workforce.</p>
        </div>
      </div>
    </div>
  </div>
  <div class="container mobile-only-section">
    <div class="card bg-white shadow-lg rounded-lg p-4">
      <h2 class="font-bold text-xl mb-2">Business Computing Solutions</h2>
      <img src="assets/images/enterprisecomputing_new.png" alt="Enterprise Computing Solutions"
        class="full-width-image rounded-lg mb-4">
      <p style="font-size: 11px;line-height: 1.5;color: #000;">At Superior Digital, we redefine business computing
        for
        today's dynamic business landscape. From seamless device deployment and cross-platform integration to
        advanced security, cloud services, and remote management, our business solutions are built to boost
        productivity and simplify IT.</p>
      <p style="font-size: 11px;line-height: 1.5;color: #000;">With our expertise in Apple and multi-brand ecosystems,
        we
        empower organizations with scalable, secure, and future-ready infrastructure that adapts to the evolving
        needs of a hybrid workforce.</p>
    </div>
  </div>
</section>
<br>
<section class="superior-computing-solutions ptb-50" id="mobility-for-modern-enterprise">
  <div class="container web-only-section">
    <div class="bg-cover bg-center rounded-lg shadow-lg"
      style="background-image: url('assets/images/mobility_ent_new.png'); min-height: 600px; position: relative; border-radius: 0 20px 20px 0;">
      <div class="flex items-center h-full"
        style="position: absolute; left: 0; top: 0; bottom: 0; width: 50%; background: linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%);">
        <div class="text-white p-8" style="background-color: rgb(0 0 0 / 19%); padding: 4.5%;height: 100%;">
          <h1 class="font-bold mb-4" style="font-size: 40px; color: #fff;">Mobility for Modern Business</h1>
          <p class="text-lg mb-6" style="font-size: 18px;">In today's fast-moving digital landscape, mobility is
            essential for driving productivity, flexibility, and business continuity. At Superior Digital, we simplify
            business mobility by combining the right hardware, software, and expertise to ensure your teams can work
            securely from anywhere. Our solutions include Mobile Device Management (MDM) for effortless deployment,
            control, and security of devices across your organisation, as well as scalable storage solutions to ensure
            seamless access to data when and where it's needed. With our end-to-end support, we make mobility easy to
            manage—empowering your workforce and future-proofing your business.</p>
        </div>
      </div>
    </div>
  </div>
  <div class="container mobile-only-section">
    <div class="card bg-white shadow-lg rounded-lg p-4">
      <h2 class="font-bold text-xl mb-2">Mobility for Modern Business</h2>
      <img src="assets/images/mobility_ent_new.png" alt="Mobility for Modern Business"
        class="full-width-image rounded-lg mb-4">
      <p style="font-size: 11px;line-height: 1.5;color: #000;">In today's fast-moving digital landscape, mobility is
        essential for driving productivity, flexibility, and business continuity. At Superior Digital, we simplify
        business mobility by combining the right hardware, software, and expertise to ensure your teams can work
        securely from anywhere. Our solutions include Mobile Device Management (MDM) for effortless deployment,
        control, and security of devices across your organisation, as well as scalable storage solutions to ensure
        seamless access to data when and where it's needed. With our end-to-end support, we make mobility easy to
        manage empowering your workforce and future proofing your business.</p>
    </div>
  </div>
</section>
<br>

<section class="what-we-offer ptb-100" style="background-color: #f9f9f9; text-align: center;">
  <div class="container">
    <div class="">
      <h2 style="font-size: 18px; font-weight: bold; color: #e43a35;">What We Offer.</h2>
      <div class="" style="background-color: transparent; border-radius: 10px; padding: 20px 20px;">
        <h1 style="color: #000; text-align: center; font-size: 30px;">Our Technology Solutions for Business</h1>
        <p style="font-size: 18px; color: #000; max-width: 900px; margin: 0 auto;">At Superior Digital, we provide
          everything you need all in one place. From strategy to execution, our end-to-end support ensures your success
          is fully backed at every stage. Whether you're facing routine operations or complex challenges, we're ready
          with reliable solutions tailored to your needs.</p>
      </div>
    </div>
    <div class="ptb-50" style="text-align: center;">
      <div class="row" style="margin-left: 0 !important">
        <div class="col-lg-6">
          <div class="offer-card"
            style="background-color: #e43a35; border-radius: 10px; padding: 20px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); display: flex; flex-direction: row; justify-content: space-between; align-items: center; gap: 20px;">
            <div class="content-section" style="flex: 1; text-align: left;">
              <h3 style="font-size: 24px; font-weight: bold; color: #fff; margin-bottom: 15px;">Computing</h3>
              <div class="image-section mobile-only-section" style="text-align: center; margin-bottom: 15px;">
                <img src="assets/images/computing_new.png" alt="Consulting"
                  style="width: 200px; height: 200px; border: 2px solid #fff; object-fit: cover;">
              </div>
              <ul style="color: #fff; text-align: left; padding-left: 20px; list-style-type: disc; margin: 0;">
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Desktops </li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Laptops </li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Workstations </li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Servers </li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Storage </li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Accessories </li>
              </ul>
            </div>
            <div class="image-section web-only-section" style="flex: 0 0 auto;">
              <img src="assets/images/computing_new.png" alt="Consulting"
                style="width: 200px; height: 200px; border: 2px solid #fff; object-fit: cover;">
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="offer-card"
            style="background-color: #000; border-radius: 10px; padding: 20px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); display: flex; flex-direction: row; justify-content: space-between; align-items: center; gap: 20px;">
            <div class="content-section" style="flex: 1; text-align: left;">
              <h3 style="font-size: 24px; font-weight: bold; color: #fff; margin-bottom: 15px;">Networking</h3>
              <div class="image-section mobile-only-section" style="text-align: center; margin-bottom: 15px;">
                <img src="assets/images/networking_new1.png" alt="Consulting"
                  style="width: 200px; height: 200px; border: 2px solid #fff; object-fit: cover;">
              </div>
              <ul style="color: #fff; text-align: left; padding-left: 20px; list-style-type: disc; margin: 0;">
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Site Readiness Check</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Cabling</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Routing</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Switching</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Testing</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Cabling Certification</li>
              </ul>
            </div>
            <div class="image-section web-only-section" style="flex: 0 0 auto;">
              <img src="assets/images/networking_new1.png" alt="Consulting"
                style="width: 200px; height: 200px; border: 2px solid #fff; object-fit: cover;">
            </div>
          </div>
        </div>
      </div>
      <br>
      <div class="row" style="margin-left: 0 !important">
        <div class="col-lg-6">
          <div class="offer-card"
            style="background-color: #000; border-radius: 10px; padding: 20px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); display: flex; flex-direction: row; justify-content: space-between; align-items: center; gap: 20px;">
            <div class="content-section" style="flex: 1; text-align: left;">
              <h3 style="font-size: 24px; font-weight: bold; color: #fff; margin-bottom: 15px;">Mobility</h3>
              <div class="image-section mobile-only-section" style="text-align: center; margin-bottom: 15px;">
                <img src="assets/images/mobility_new2.png" alt="Consulting"
                  style="width: 200px; height: 200px; border: 2px solid #fff; object-fit: cover;">
              </div>
              <ul style="color: #fff; text-align: left; padding-left: 20px; list-style-type: disc; margin: 0;">
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">iPhone</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">iPad</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Android Devices</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Mobile Device Management</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Software Integration</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Accessories</li>
              </ul>
            </div>
            <div class="image-section web-only-section" style="flex: 0 0 auto;">
              <img src="assets/images/mobility_new2.png" alt="Consulting"
                style="width: 200px; height: 200px; border: 2px solid #fff; object-fit: cover;">
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="offer-card"
            style="background-color: #e43a35; border-radius: 10px; padding: 20px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); display: flex; flex-direction: row; justify-content: space-between; align-items: center; gap: 20px;">
            <div class="content-section" style="flex: 1; text-align: left;">
              <h3 style="font-size: 24px; font-weight: bold; color: #fff; margin-bottom: 15px;">Software</h3>
              <div class="image-section mobile-only-section" style="text-align: center; margin-bottom: 15px;">
                <img src="assets/images/software_new1.png" alt="Consulting"
                  style="width: 200px; height: 200px; border: 2px solid #fff; object-fit: cover;">
              </div>
              <ul style="color: #fff; text-align: left; padding-left: 20px; list-style-type: disc; margin: 0;">
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Creative</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Engineering</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Productivity</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">ERP</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Collaboration</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">SaaS Applications</li>
              </ul>
            </div>
            <div class="image-section web-only-section" style="flex: 0 0 auto;">
              <img src="assets/images/software_new1.png" alt="Consulting"
                style="width: 200px; height: 200px; border: 2px solid #fff; object-fit: cover;">
            </div>
          </div>
        </div>
      </div>
      <br>
      <div class="row" style="margin-left: 0 !important">
        <div class="col-lg-6">
          <div class="offer-card"
            style="background-color: #e43a35; border-radius: 10px; padding: 20px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); display: flex; flex-direction: row; justify-content: space-between; align-items: center; gap: 20px;">
            <div class="content-section" style="flex: 1; text-align: left;">
              <h3 style="font-size: 24px; font-weight: bold; color: #fff; margin-bottom: 15px;">Audio - Video</h3>
              <div class="image-section mobile-only-section" style="text-align: center; margin-bottom: 15px;">
                <img src="assets/images/audio-video1.png" alt="Consulting"
                  style="width: 200px; height: 200px; border: 2px solid #fff; object-fit: cover;">
              </div>
              <ul style="color: #fff; text-align: left; padding-left: 20px; list-style-type: disc; margin: 0;">
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Boardroom Solutions</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Displays/Interactive Panels</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Room Schedulers & Controllers</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Unified Communication</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Digital Signage/Video Walls</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Audio Solutions</li>
              </ul>
            </div>
            <div class="image-section web-only-section" style="flex: 0 0 auto;">
              <img src="assets/images/audio-video1.png" alt="Consulting"
                style="width: 200px; height: 200px; border: 2px solid #fff; object-fit: cover;">
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="offer-card"
            style="background-color: #000; border-radius: 10px; padding: 20px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); display: flex; flex-direction: row; justify-content: space-between; align-items: center; gap: 20px;">
            <div class="content-section" style="flex: 1; text-align: left;">
              <h3 style="font-size: 24px; font-weight: bold; color: #fff; margin-bottom: 15px;">Managed Services</h3>
              <div class="image-section mobile-only-section" style="text-align: center; margin-bottom: 15px;">
                <img src="assets/images/managed_service_new.png" alt="Consulting"
                  style="width: 200px; height: 200px; border: 2px solid #fff; object-fit: cover;">
              </div>
              <ul style="color: #fff; text-align: left; padding-left: 20px; list-style-type: disc; margin: 0;">
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">⁠Onsite Support on Demand</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Annual Maintenance Contract</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Dedicated Service Engineer</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Per Incident Support</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">Breakdown Support</li>
                <li style="font-size: 16px; text-align: left; margin-bottom: 8px;">IT Hardware Repair Services</li>
              </ul>
            </div>
            <div class="image-section web-only-section" style="flex: 0 0 auto;">
              <img src="assets/images/managed_service_new.png" alt="Consulting"
                style="width: 200px; height: 200px; border: 2px solid #fff; object-fit: cover;">
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<section class="service-support-section"
  style="padding: 60px 0; background-image: url('assets/images/service&support_new.png'); background-size: cover; background-position: center; background-attachment: fixed; position: relative;">
  <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.7);"></div>
  <div class="container" style="position: relative; z-index: 1;">
    <h2 class="text-center" style="font-size: 34px; color: #fff; font-weight: bold;">Service & Support</h2>
    <p class="text-center mb-5" style="font-size: 1.1rem; color: #fff; max-width: 800px; margin: 0 auto;">
      Comprehensive support solutions to keep your business running smoothly
    </p>

    <div class="row" style="display: flex; flex-wrap: wrap; gap: 30px; justify-content: center;">
      <!-- Technical Support Card -->
      <div class="support-card"
        style="flex: 1; min-width: 300px; max-width: 350px; background: rgba(255, 255, 255, 0.95); border-radius: 15px; padding: 30px; box-shadow: 0 4px 6px rgba(0,0,0,0.1); transition: transform 0.3s ease; backdrop-filter: blur(5px);">
        <div class="icon-container"
          style="width: 70px; height: 70px; background: #e43a35; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
          <i class="fas fa-headset" style="font-size: 30px; color: white;"></i>
        </div>
        <h3 style="font-size: 1.3rem; color: #333; margin-bottom: 15px;">Dedicated Technical Support</h3>
        <p style="color: #666; line-height: 1.6;">
          Technical assistance for all your IT needs. Our expert team is always ready to help.
        </p>
        <ul style="list-style: none; padding: 0; margin-top: 20px;">
          <li style="margin-bottom: 10px; display: flex; align-items: center;">
            <i class="fas fa-check" style="color: #e43a35; margin-right: 10px;"></i>
            Remote Support
          </li>
          <li style="margin-bottom: 10px; display: flex; align-items: center;">
            <i class="fas fa-check" style="color: #e43a35; margin-right: 10px;"></i>
            On-site Assistance
          </li>
          <li style="margin-bottom: 10px; display: flex; align-items: center;">
            <i class="fas fa-check" style="color: #e43a35; margin-right: 10px;"></i>
            Priority Response
          </li>
        </ul>
      </div>

      <!-- Maintenance Card -->
      <div class="support-card"
        style="flex: 1; min-width: 300px; max-width: 350px; background: rgba(255, 255, 255, 0.95); border-radius: 15px; padding: 30px; box-shadow: 0 4px 6px rgba(0,0,0,0.1); transition: transform 0.3s ease; backdrop-filter: blur(5px);">
        <div class="icon-container"
          style="width: 70px; height: 70px; background: #e43a35; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
          <i class="fas fa-tools" style="font-size: 30px; color: white;"></i>
        </div>
        <h3 style="font-size: 1.3rem; color: #333; margin-bottom: 15px;">Preventive Maintenance</h3>
        <p style="color: #666; line-height: 1.6;">
          Regular maintenance and monitoring to prevent issues before they impact your business.
        </p>
        <ul style="list-style: none; padding: 0; margin-top: 20px;">
          <li style="margin-bottom: 10px; display: flex; align-items: center;">
            <i class="fas fa-check" style="color: #e43a35; margin-right: 10px;"></i>
            System Health Checks
          </li>
          <li style="margin-bottom: 10px; display: flex; align-items: center;">
            <i class="fas fa-check" style="color: #e43a35; margin-right: 10px;"></i>
            Performance Optimization
          </li>
          <li style="margin-bottom: 10px; display: flex; align-items: center;">
            <i class="fas fa-check" style="color: #e43a35; margin-right: 10px;"></i>
            Regular Updates
          </li>
        </ul>
      </div>

      <!-- Training Card -->
      <div class="support-card"
        style="flex: 1; min-width: 300px; max-width: 350px; background: rgba(255, 255, 255, 0.95); border-radius: 15px; padding: 30px; box-shadow: 0 4px 6px rgba(0,0,0,0.1); transition: transform 0.3s ease; backdrop-filter: blur(5px);">
        <div class="icon-container"
          style="width: 70px; height: 70px; background: #e43a35; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
          <i class="fas fa-graduation-cap" style="font-size: 30px; color: white;"></i>
        </div>
        <h3 style="font-size: 1.3rem; color: #333; margin-bottom: 15px;">Training & Education</h3>
        <p style="color: #666; line-height: 1.6;">
          Comprehensive training programs to help your team make the most of your technology investments.
        </p>
        <ul style="list-style: none; padding: 0; margin-top: 20px;">
          <li style="margin-bottom: 10px; display: flex; align-items: center;">
            <i class="fas fa-check" style="color: #e43a35; margin-right: 10px;"></i>
            Custom Workshops
          </li>
          <li style="margin-bottom: 10px; display: flex; align-items: center;">
            <i class="fas fa-check" style="color: #e43a35; margin-right: 10px;"></i>
            Online Resources
          </li>
          <li style="margin-bottom: 10px; display: flex; align-items: center;">
            <i class="fas fa-check" style="color: #e43a35; margin-right: 10px;"></i>
            Certification Programs
          </li>
        </ul>
      </div>
    </div>

    <div class="support-cta" style="text-align: center; margin-top: 50px;">
      <a href="/contact"
        style="display: inline-block; background-color: #e43a35; color: white; padding: 15px 30px; border-radius: 5px; text-decoration: none; font-weight: bold; transition: all 0.3s ease; border: 2px solid #e43a35;"
        onmouseover="this.style.backgroundColor='transparent'; this.style.color='#fff';"
        onmouseout="this.style.backgroundColor='#e43a35'; this.style.color='#fff';">
        Get Support Now
      </a>
    </div>
  </div>
</section>

<!-- Partnerships Section -->
<section class="partnerships-section">
  <div class="container">
    <h2 class="partnerships-title">Partnerships</h2>
    <div class="partnerships-grid">
      <div class="partnerships-col">
        <div class="partnerships-header">
          <!-- <img src="assets/images/superior-logo-whiteBG.jpg" alt="Your Logo" class="partner-main-logo" /> -->
          <div class="apple-authorized">
            <img src="assets/images/authorized.png" alt="Apple Logo" class="apple-logo" />
            <!-- <span>Authorized Reseller</span> -->
          </div>
        </div>
      </div>

      <div class="partnerships-col">
        <div class="partnerships-category">
          <h3>IT Hardware Solution</h3>
          <div class="partner-logos">
            <img src="assets/images/partnershiplogo/hp.png" alt="Hp" style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/apple.png" alt="Apple" style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/dell.png" alt="Dell" style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/lenovo.png" alt="Lenovo" style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/acer.png" alt="Acer" style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/asus.png" alt="Asus" style="background-color: transparent;" />
            <img src="assets/images/marquee/microsoft.png" alt="Microsoft" style="background-color: transparent;" />
          </div>
        </div>
        <div class="partnerships-category">
          <h3>Video Wall Partners</h3>
          <div class="partner-logos">
            <img src="assets/images/partnershiplogo/lg_display.png" alt="LG" style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/planar.png" alt="planar" style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/samsung.png" alt="samsung" style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/delta.png" alt="delta" style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/barco.jpg" alt="barco" style="background-color: transparent;" />
          </div>
        </div>
        <div class="partnerships-category">
          <h3>Server Partners</h3>
          <div class="partner-logos">
            <img src="assets/images/partnershiplogo/hp_enterprise.jpg" alt="hewlett"
              style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/lenovo_think.png" alt="lenovo"
              style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/ibm.png" alt="IBM" style="background-color: transparent;" />
          </div>
        </div>

      </div>


      <div class="partnerships-col">
        <div class="partnerships-category">
          <h3>Video Conferencing Partners</h3>
          <div class="partner-logos">
            <img src="assets/images/partnershiplogo/poly.png" alt="pply" style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/lifesize.jpg" alt="lifesize"
              style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/zoom.png" alt="zoom" style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/avaya.png" alt="avaya" style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/peoplelink.png" alt="peoplelink"
              style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/logitech.png" alt="logitech"
              style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/yealink.png" alt="yealink" style="background-color: transparent;" />
            <!-- <img src="assets/images/marquee/intune.png" alt="Microsoft Intune" /> -->
          </div>
        </div>
        <div class="partnerships-category">
          <h3>Cloud Partners</h3>
          <div class="partner-logos">
            <img src="assets/images/partnershiplogo/dropbox.png" alt="dropbox" style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/gcloud.png" alt="google" style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/aws.jpg" alt="aws" style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/salesforce.png" alt="salesforce"
              style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/azure.png" alt="azure" style="background-color: transparent;" />
          </div>
        </div>
        <div class="partnerships-category">
          <h3>Leasing & Financing Partners</h3>
          <div class="partner-logos">
            <img src="assets/images/partnershiplogo/tata.png" alt="tata" style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/ra.jpg" alt="ra" style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/csi.png" alt="cs" style="background-color: transparent;" />
          </div>
        </div>

      </div>


      <div class="partnerships-col">

        <div class="partnerships-category">
          <h3>Networking Partners</h3>
          <div class="partner-logos">
            <img src="assets/images/partnershiplogo/dellemc.png" alt="Dell EMC"
              style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/veeam.png" alt="Veeam" style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/citrix.png" alt="Citrix" style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/cisco.jpg" alt="cisco" style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/velocloud.jpg" alt="velocloud"
              style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/vmware.png" alt="vmware" style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/hewlett.jpg" alt="hewlett packard"
              style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/commvault.png" alt="commvault"
              style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/nutanix.png" alt="nutanix" style="background-color: transparent;" />
          </div>
        </div>


        <div class="partnerships-category">
          <h3>Datacenter Partners</h3>
          <div class="partner-logos">
            <img src="assets/images/partnershiplogo/dellemc.png" alt="dell emc"
              style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/vantage_datacenter.png" alt="vantage"
              style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/ibm.png" alt="IBM" style="background-color: transparent;" />
            <img src="assets/images/partnershiplogo/hp_enterprise.jpg" alt="hp"
              style="background-color: transparent;" />
          </div>
        </div>
      </div>

    </div>
  </div>
</section>

